import React from 'react';
import BEM from 'common/bem';

const classes = BEM.with('TigerAgentPane');

const TIGER_AGENT_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_TIGER_AGENT_URL) || '';

function TigerAgentPane() {
  if (!TIGER_AGENT_URL) return null;

  return <iframe src={TIGER_AGENT_URL} title="Tiger Agent" className={classes('iframe')} />;
}

export default TigerAgentPane;
